export const ApiConfig = {
    API_KEY: '75018f5e-84a4-41f9-acbe-60965ef56031',
    API_URL: "https://bbcrm.bbsway.it/public/forms",
    CLIENT_URL: "https://bschool.it/placement-test"
}